import React, { ReactNode } from "react";

interface FooterLogoProps {
  logo: ReactNode;
}

export const FooterLogo: React.FC<FooterLogoProps> = ({
  logo,
}: FooterLogoProps) => {
  return <div className="footer__logo">{logo}</div>;
};
